import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import Formulario, { FormField } from "../../../components/Formulario";
import { createTipo } from "../../../api/tipoApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdicionarTipo: React.FC = () => {
  const [nomeTipo, setNomeTipo] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      const formData = new FormData();
      formData.append("nome_tipo", nomeTipo);

      await createTipo(token, formData);
      toast.success("Tipo criado com sucesso!");
      navigate("/tipos");
    } catch (error) {
      toast.error("Erro ao adicionar tipo!");
      console.error("Erro ao adicionar tipo:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const fields: FormField[] = [
    {
      label: "Nome do Tipo",
      type: "text",
      value: nomeTipo,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNomeTipo(e.target.value),
    },
  ];

  return (
    <Formulario
      title="Adicionar Tipo"
      fields={fields}
      onSubmit={handleSubmit}
      loading={loading}
      onBack={handleBack}
    />
  );
};

export default AdicionarTipo;
